import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  //resultParte:[],
  //dataNotFound: [],
  //resultNotificacion: [],
  //currentParte: {},
  listTocas:[],
  newToca:[],
  listPartesToca:[],
};
export const mutations = {
  SAVE_TOCAS({ context }, toca) {
    state.newToca= Object.assign({}, toca);
  },
  // dataNotFound({ context }, data) {
  //   state.dataNotFound = data
  // },
  GET_TOCAS({ context }, parte_id) {
    state.resultToca = Object.assign({}, parte_id);
  },
  CONSULTAR_TOCAS({ context }, data) {
    state.listTocas = data;
  },
  GET_PARTES_TOCA({ context }, data) {
    state.listPartesToca = data;
  },
};
export const actions = {

  SAVE_TOCAS({ commit }, toca) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.addToca(toca)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_TOCAS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_TOCAS({ commit }, parte_id) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getTocas(parte_id)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_TOCAS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  CONSULTAR_TOCAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      //console.log(data);
      ApiService.getTocas(data)
        .then(response => {
          //console.log(response);
          commit("SET_LOADING", false);
          commit("CONSULTAR_TOCAS", response.data.data.tocas.data);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_PARTES_TOCA({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      //console.log(data);
      ApiService.getPartesByToca(data)
        .then(response => {
          //console.log(response.data.data.tocas);
          commit("SET_LOADING", false);
          commit("GET_PARTES_TOCA", response.data.data.tocas);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  CONFIRM_TOCA({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.confirmToca(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_TOCAS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  CANCEL_TOCA({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.cancelToca(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_TOCAS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SHOW_TOCA({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.showToca(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_TOCAS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_ACUSE({ commit }, [notificacion_id,tipo]) {
    console.log('GET',tipo);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      console.log(notificacion_id);
      ApiService.generateAcuse(notificacion_id,tipo)
        .then(response => {
          //console.log(response.data.data.tocas);
          commit("SET_LOADING", false);
          commit("GET_PARTES_TOCA", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  CONFIRM_ACUERDO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.confirmAcuerdo(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_TOCAS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};

export const getters = {//leer datos
  //currentParte: state => state.currentParte,
  //dataNotFound: state => state.dataNotFound,
  newToca: state => state.newToca,
  listTocas: state => state.listTocas,
  listPartesToca: state => state.listPartesToca
};
